













import Vue from "vue";
import { WithTitle } from "@/models";

interface Props {
  section?: WithTitle;
}

/**
 * Slots:
 *
 * `before`     : out of the content box
 * (default)    : the content of the section
 */
export default Vue.extend<Props>({
  name: "SectionDefault",
  functional: true,
  props: {
    section: {
      type: Object,
      required: false,
      default: undefined,
      validator: section => {
        if (section === undefined) return true;
        return section.title !== undefined;
      }
    }
  }
});
